import { render, staticRenderFns } from "./marketCodeBatch.vue?vue&type=template&id=b1fb9b20&"
import script from "./marketCodeBatch.vue?vue&type=script&lang=js&"
export * from "./marketCodeBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports